import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], filteredProperty: string, term?: any): any {
    if (!term || !filteredProperty || !items || items.length < 1) { return items; }
    return items.filter(y => y[filteredProperty].toLowerCase().indexOf(term.toLowerCase()) !== -1);
  }

}
